/**
 * Workflow Patterns
 * Multi-step workflows and wizards
 */

import React from "react";

export interface WorkflowStep {
  key: string;
  title: string;
  completed?: boolean;
  active?: boolean;
  disabled?: boolean;
}

export interface WorkflowProps {
  children: React.ReactNode;
  steps: WorkflowStep[];
  currentStep?: string;
  onStepChange?: (stepKey: string) => void;
  showProgress?: boolean;
  className?: string;
}

export function Workflow({
  children,
  steps,
  currentStep,
  onStepChange,
  showProgress = true,
  className,
  ...props
}: WorkflowProps) {
  // Implementation will be added later
  return (
    <div className={className} {...props}>
      {showProgress && (
        <nav>
          {steps.map((step) => (
            <button
              key={step.key}
              onClick={() => onStepChange?.(step.key)}
              disabled={step.disabled}
            >
              {step.title}
            </button>
          ))}
        </nav>
      )}
      <main>{children}</main>
    </div>
  );
}
